import React, { Fragment} from "react";
import {Link} from "react-router-dom";
import {getChildRouterLink} from "root/Wieldy/routePaths";
import {getDefaultChildViewPage} from "root/DataFunctions/PageContentRoles";
import {UserTypes} from "root/DataFunctions/Constants";
import {getDocumentUrl} from "root/DataFunctions/CommonDataFns";
import Floater from "react-floater";
import {useGlobalContext} from "root/contexts/GlobalContext";

const ChildDetailSidebarEntry = (props) =>
{
    const defaultPage = getDefaultChildViewPage ( props ) ;

    const { userType } = useGlobalContext() ;

    const hide_user_image = (userType === UserTypes.BIRTH_PARENT || userType === UserTypes.OTHER);

    const hasNoRole = props.childDetails.is_contributor === false &&
                              props.childDetails.is_messager === false &&
                              props.childDetails.is_editor === false && props.childDetails.is_manager === false;

    const getUserImage = () =>
    {
        const document_id = props.childDetails.document_id;

        //get the image if data and user is permitted to see image
        const url = document_id === null || hide_user_image ? '/images/defaultPerson.jpg': getDocumentUrl(document_id);
        return url
    }

    const floaterStyles = {
        container: {
            borderRadius: '10px',
            backgroundColor: '#dce8f1',
            zIndex: 1000
        },
        arrow: {
            color: '#dce8f1'
        },
    } ;

    const blockedText = () =>{
        const text = 'You have been blocked by this user. Please contact your ARCBOX administrator to discuss the reasons why.';
        return text;
    } ;

    const noRoleText = () =>{
        const text = 'At the present time you do not have permission to make contact directly.';
        return text;
    } ;

    return (
        <Fragment>
            {+props.childDetails.blocked === 0 && !hasNoRole && <Link to={getChildRouterLink(props.childDetails.child_uid, defaultPage )} key={props.keyName}>
                <div className="child-menu-item">
                    <img alt="image" src={getUserImage()} width="50px" align="left" />
                    <div style={{textAlign: 'left', alignSelf: 'center'}}>
                        <span>{props.childDetails.known_as}</span>
                    </div>
                </div>
            </Link>}

            {+props.childDetails.blocked === 1 &&
                <Floater content={blockedText()} event='hover' styles={{floaterStyles}}>
                    <div className="child-menu-item-blocked">

                        <img alt="image" src={getUserImage()} width="50px" align="left"/>

                        <div style={{textAlign: 'left', alignSelf: 'center'}}>
                            <span>{props.childDetails.known_as}</span><p class={'icon icon-exclamation icon-fw icon-lg floater-warning'}></p>
                        </div>
                    </div>
                </Floater>
            }

            {hasNoRole && +props.childDetails.blocked === 0 &&
                <Floater content={noRoleText()} event='hover' styles={{floaterStyles}}>
                    <div className="child-menu-item-blocked">

                        <img alt="image" src={getUserImage()} width="50px" align="left"/>

                        <div style={{textAlign: 'left', alignSelf: 'center'}}>
                            <span>{props.childDetails.known_as}</span><p class={'icon icon-exclamation icon-fw icon-lg floater-warning'}></p>
                        </div>
                    </div>
                </Floater>
            }
        </Fragment>
    )
}
export default ChildDetailSidebarEntry;
